import IconTimer from '@picsart/icons/IconTimer';
import IconTickCircleOutline from '@picsart/icons/IconTickCircleOutline';
import IconLearn from '@picsart/icons/IconLearn';
import IconLabels from '@picsart/icons/IconLabels';
import cls from 'classnames';

import useStyles from './styles';
import { TagLineProps } from './types';

const TAG_ICONS = [IconTimer, IconTickCircleOutline, IconLearn, IconLabels];

function TagLines({ items, className, listClassName }: TagLineProps) {
  const classes = useStyles();

  return (
    <section className={cls(classes.root, className)}>
      <ul className={cls('flex', classes.lst, listClassName)}>
        {items.map((item, i) => {
          const { Icon, text } = item;
          const IconTag = Icon || TAG_ICONS[i];

          return (
            <li key={`tagl-${i}`} className={cls('align-center', classes.container)}>
              <div className={cls('flex', 'justify-center', 'align-center', classes.iconContainer)}>
                <IconTag className={classes.icon} />
              </div>
              <span className={classes.text}>{text}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
}

export default TagLines;
